import DeleteSkillModal from './DeleteSkillModal'

export default DeleteSkillModal
